import { Box, Typography, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import searchEngine from '../Core/SearchEngine';
import useSearchQuery from '../useSearchQuery';
import useSearchResults from '../useSearchResults';

/**
 * Shows result count and pagination controls.
 * Calls its own hooks directly — no Context, no prop drilling.
 */
export default function SearchMetaBar() {
    const query = useSearchQuery();
    const { total, page, pageSize, loading } = useSearchResults();
    const totalPages = Math.ceil(total / pageSize) || 1;

    return (
        <Box className="ys-meta">
            <Typography className="ys-meta-count" sx={{ fontSize: '11px' }}>
                {total > 0 ? `${total} results` : query.length >= 3 && !loading ? 'No results' : ''}
            </Typography>
            {total > pageSize && (
                <Box className="ys-pager">
                    <IconButton size="small" onClick={() => searchEngine.loadPage(page - 1)} disabled={page <= 1} sx={{ color: '#a3d1ff' }}>
                        <ChevronLeft fontSize="small" />
                    </IconButton>
                    <Typography variant="caption" sx={{ color: '#a3d1ff', fontSize: '11px' }}>
                        {page} / {totalPages}
                    </Typography>
                    <IconButton
                        size="small"
                        onClick={() => searchEngine.loadPage(page + 1)}
                        disabled={page >= totalPages}
                        sx={{ color: '#a3d1ff' }}
                    >
                        <ChevronRight fontSize="small" />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
}
